export default __webpack_public_path__ + "static/media/logo.303d1dcb.svg";